// extracted by mini-css-extract-plugin
export default {"grid":"Services_grid__+eaUm","icon":"Services_icon__JNtS5","name":"Services_name__5ofGq","desc":"Services_desc__bXYjA","tags":"Services_tags__Ouvm6"};